<template>
  <div id="welcomeView">
    <div id="welcomeContentContainer">
      <div id="welcomeSideBanner"> <!-- TODO: MAKE ALL OF THIS CONTENT DEPENDENT ON ROUND, LOGIN, AND/OR COMPLETION STATUS -->
        <!-- <div id="sideBannerCurrentRound" class="side-banner-item" v-if="currentRound > 1">Team Round<br/><span class="highlighted-banner-info">{{ (currentRound - 1) }}</span> of {{ (rounds.length - 2) }}</div> -->
        <div id="sideBannerCurrentRound" class="side-banner-item" v-if="currentRound > 1"><span class="highlighted-banner-info">Team</span><br/>Round</div>
        <div id="sideBannerCurrentRound" class="side-banner-item" v-else><span class="highlighted-banner-info">Solo</span><br/>Round</div>
<!--         <div id="sideBannerRoundStartInfo" class="side-banner-item">
          STARTS:<br/>
          <span class="highlighted-banner-info" v-html="prettyTimestamp(rounds[currentRound].startTime)"></span>
        </div>
        <div id="sideBannerRoundEndInfo" class="side-banner-item">
          ENDS:<br/>
          <span class="highlighted-banner-info" v-html="prettyTimestamp(rounds[currentRound].endTime)"></span>
        </div> -->
      </div>
      <div id="welcomeContent">
        <div id="welcomeMessage"  v-html="rounds[currentRound].introMessage"></div>
        <!-- <div id="relativeStartTime" v-html="generateNextRoundMessage()"></div> -->
        <div id="startButton" class="game-button zoom-in-out" @click="startLogin" v-if="currentUser === null">
          Log In >>
        </div>
        <div id="roundStartMessage" v-if="currentUser && !unlocked">
          Waiting for the round to start...
        </div>
        <div id="startButton" class="game-button zoom-in-out" @click="startGame" v-if="currentUser && unlocked">
          Start
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Howl } from 'howler'

export default {
  name: 'Welcome',
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'currentUser',
      'currentView',
      'currentRound',
      'rounds',
      'unlocked',
    ]),
  },
  methods: {
    ...mapActions([
      'onResize',
      'toggleLoginModal',
      'updateCurrentView'
    ]),
    prettyTimestamp(timestamp){
      let formattedDate = new Date((timestamp * 1000)).toLocaleDateString('en-US');
      let formattedTime = new Date((timestamp * 1000)).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'});
      return `${formattedDate}<br/>${formattedTime}`;
    },
    startLogin(){
      const theWelcomeView = this;
      if(!theWelcomeView.startSound){
        let tempSound = new Howl({
          src: ['./assets/common/audio/game_start.mp3'],
          volume: 1,
          onload: () => {
            theWelcomeView.startSound = tempSound;
            tempSound.play()
          },
          onloaderror: (id, error) => {
            console.log(error)
          }
        });
      }else{
        theWelcomeView.startSound.play()
      }
      theWelcomeView.toggleLoginModal()
    },
    startGame(){
      const theWelcomeView = this;
      theWelcomeView.updateCurrentView('question')
    },
    generateNextRoundMessage(){
      const theWelcomeView = this;
      const msPerDay = (1000 * 60 * 60 * 24);

      let returnedMessage = '';

      let curTime = Math.floor(Date.now());
      let roundStartTime = (theWelcomeView.rounds[theWelcomeView.currentRound].startTime * 1000);
      let roundEndTime = (theWelcomeView.rounds[theWelcomeView.currentRound].endTime * 1000);

      let remainingDays = 0;
      
      // calc remaining days for current round
      if(roundEndTime >= curTime){
        remainingDays = Math.floor((roundEndTime - curTime) / msPerDay);
      }else{
        remainingDays = Math.floor((curTime - roundEndTime) / msPerDay);
      }

      let roundExpired = !(curTime >= roundStartTime && curTime <= roundEndTime);
      let gameStarted = (curTime > (theWelcomeView.rounds[0].startTime * 1000));
      let daysTilStart = (Math.floor((roundStartTime - curTime) / msPerDay));

      if(!gameStarted){
        returnedMessage = `THE GAME IS NOT YET AVAILABLE.<br/>THE FIRST ROUND WILL START IN ${daysTilStart} ${daysTilStart > 1 ? 'DAYS' : 'DAY'}`;
      }else if(roundExpired){
        if(!theWelcomeView.rounds[theWelcomeView.currentRound + 1]){
          returnedMessage = `THE GAME HAS CONCLUDED.<br/>YOU MAY STILL LOG IN TO VIEW YOUR SCORE AND PLACEMENT.`;
        }else{
          // recalc remaining days against start of next round
          let nextRoundStartTime = (theWelcomeView.rounds[theWelcomeView.currentRound + 1].startTime * 1000);
          remainingDays = Math.floor((nextRoundStartTime - curTime) / msPerDay);

          returnedMessage = `THE ROUND HAS CONCLUDED.<br/>THE NEXT ROUND WILL START IN ${remainingDays} ${remainingDays > 1 ? 'DAYS' : 'DAY'}`
        }
      }else{
        returnedMessage = `THIS ROUND ENDS IN ${remainingDays} ${remainingDays > 1 ? 'MORE DAYS' : 'MORE DAY'}`
      }

      return returnedMessage;
    }
  },
  mounted(){

  },
  data(){
    return {
      startSound: null,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #welcomeView{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #welcomeView{
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;
  }

  #welcomeContentContainer{
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  #welcomeSideBanner{
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: flex-start;
    padding-top: 20px;
    width: 100%;
    height: 489px;
    max-width: 233px;
    background-image: url('~@/assets/img/content_side_banner_background.png');
    background-size: contain;
    background-repeat: no-repeat;
    font-weight: bold;
    font-size: 30px;
    line-height: 1.2em;
  }

  >>> .side-banner-item .highlighted-banner-info{
    font-size: 30px;
  }

  .side-banner-item:first-child{
    margin-top: 10px;
  }

  .side-banner-item{
    text-align: center;
    margin-bottom: 20px;
  }


  #welcomeContent{
    padding: 10px;
    padding-right: 230px;
    width: 100%;
/*    max-width: calc(100% - 233px);*/
  }
  #welcomeMessage{
    font-size: 30px;
    line-height: 1.2em;
    text-align: center;
  }

  >>> .round-number{
    font-size: 24px;
    font-style: italic;
  }

  >>> .round-theme{
    font-weight: bold;
  }

  #relativeStartTime{
    font-size: 10px;
    font-weight: bold;
    margin: 0 auto;
    max-width: 350px;
    margin-top: 50px;
    text-align: center;
    line-height: 1em;
  }

  #roundStartMessage{
    font-size: 16px;
    font-style: italic;
    text-align: center;
    margin-top: 10px;
    color: #fff;
  }

  #startButton{
    max-width: 250px;
    margin: 0 auto;
/*    margin-top: 50px;*/
    margin-top: 10px;
    font-size: 25px;
  }

  .zoom-in-out {
    animation: zoom-in-zoom-out 2s;
    animation-iteration-count: infinite;
  }

  @keyframes zoom-in-zoom-out {
    0% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.125, 1.125);
    }
    100% {
      transform: scale(1, 1);
    }
  }

  @media screen and (min-width: 737px) and (max-width: 796px){
    #welcomeSideBanner{
      font-size: 16px;
      line-height: 1em;
    }
    >>> .side-banner-item .highlighted-banner-info{
      font-size: 16px;
    }
  }

  @media screen and (max-width: 736px){
    #welcomeView{
      width: 100%;
    }
    #welcomeSideBanner{
      width: 120px;
      height: 330px;
      font-size: 12px;
      line-height: 1em;
    }
    >>> .side-banner-item .highlighted-banner-info{
      font-size: 12px;
    }
    #welcomeContent{
      position: relative;
      max-width: calc(100% - 120px);
    }
  }

 @media screen and (max-width: 475px){
    #welcomeContent{
      overflow-y: auto;
      height: calc(100vh - 200px);
      height: calc(100svh - 200px);
    }
  }
</style>
